frappe.ready(() => {
	const root = document.querySelector("[data-imek-product-search-page]");
	if (!root) return;

	const $root = $(root);
	const $results = $root.find(".search-results");
	const $list = $root.find("#search-list");
	const $more = $root.find(".more-btn");
	const $moreButton = $more.find("button");
	const pageLength = Number(root.dataset.pageLength || 12);
	const search = frappe.utils.get_url_arg("search") || "";
	let start = 0;

	if (search) {
		$results.text(`${root.dataset.resultsLabel}: ${search}`);
	}

	function getProductList() {
		$moreButton.prop("disabled", true);
		frappe.call({
			method: "ikart.templates.pages.product_search.get_product_list",
			args: {
				search,
				start,
				limit: pageLength,
			},
			callback(r) {
				const items = r.message || [];
				if (!start) {
					$list.empty();
				}

				if (items.length) {
					$list.append(items.join(""));
					start += items.length;
				}

				$more.toggle(items.length >= pageLength);
				$moreButton.prop("disabled", false);
			},
		}).fail(function () {
			$moreButton.prop("disabled", false);
			$results.text(root.dataset.unavailableLabel || __("Could not load products. Please try again."));
		});
	}

	$moreButton.on("click", getProductList);
	getProductList();
});
